import { render, staticRenderFns } from "./questionset.vue?vue&type=template&id=00e21f33&scoped=true"
import script from "./questionset.vue?vue&type=script&lang=js"
export * from "./questionset.vue?vue&type=script&lang=js"
import style0 from "./questionset.vue?vue&type=style&index=0&id=00e21f33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e21f33",
  null
  
)

export default component.exports